import { styles, variants } from '../FilePickerStyles.css';
import { FilePickerTheme } from '../FilePickerStyles.css';
import { baseTheme } from './FilePickerBaseTheme.css';
import { multiVariantStyles } from './FilePickerVariants.css';

/*******************
 * Component Theme
 *******************/

const FilePickerStableTheme: FilePickerTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { FilePickerStableTheme };
